import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { Router } from '@angular/router';

import {
  CHECKS_PAGE_BLOCK_DATA_SOURCE,
  CHECKS_PAGE_BLOCK_LOADING_VM,
  ChecksPageBlockDataSource,
  ChecksPageBlockViewModel,
} from './checks-page-block-view-model';
import { provideChecksPageBlockDataSource } from './checks-page-block-data-source.providers';

@Component({
  selector: 'app-checks-page-block',
  templateUrl: './checks-page-block.component.html',
  standalone: false,
  providers: [...provideChecksPageBlockDataSource()],
})
export class ChecksPageBlockComponent {
  protected readonly checksPageVm$: Observable<ChecksPageBlockViewModel>;
  protected readonly loadingVm = CHECKS_PAGE_BLOCK_LOADING_VM;

  constructor(
    @Inject(CHECKS_PAGE_BLOCK_DATA_SOURCE)
    blockDataSource: ChecksPageBlockDataSource,
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
  ) {
    this.checksPageVm$ = blockDataSource.vm$;
  }

  goToCheckDetails(id: string): void {
    this.router.navigate([this.routerHelper.translateRoute(`/checks/${id}/details`)]);
  }

  protected forceType(event: any): any {
    return event as any;
  }
}
